// CitySelector.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function CitySelector() {
  const [cities, setCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (searchTerm) {
      axios
        .get('http://localhost:5000/cities', {
          params: {
            input: searchTerm,
          },
        })
        .then((response) => {
          setCities(response.data.commune);
        })
        .catch((error) => {
          console.error('Error fetching cities:', error);
        });
    } else {
      setCities([]);
    }
  }, [searchTerm]);

  return (
    <div>
      <label htmlFor="city-search">Rechercher une ville :</label>
      <input
        type="text"
        id="city-search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {cities.length > 0 && (
        <select>
          {cities.map((city) => (
            <option key={city.city_id} value={city.libelle + ' [' + city.insee + ']'}>
              {city.libelle + ' [' + city.insee + ']'}
            </option>
          ))}
        </select>
      )}

     
    </div>
  );
}
